import Images from "./Images";
const Youtube = 'https://www.youtube.com/embed/';

const tutorialData = [
  {
    chapter: "Getting Started",
    videos: [
      {
        title: "Login & Password change process",
        videoId: `${Youtube}GDhHcZNUTWA?si=sQLLpsq7Z1DxarBM`,
        thumbnail: Images.loginProcess
      },
      {
        title: "Dashboard Overview",
        videoId: `${Youtube}aNS65B_LY_g?si=DCT1JERsVdKEkAA5`,
        thumbnail: Images.dashboardOverView
      },
    ]
  },
  {
    chapter: "Outlet",
    videos: [
      {
        title: "Outlet Management",
        videoId: `${Youtube}8I6aYCfp4Fo?si=C9Vvdx4_GqoqYkTU`,
        thumbnail: Images.outletManagement
      },
      {
        title: "Outlet Offers",
        videoId: `${Youtube}jxew-PczYtE?si=whmsrqzuHQ3JEQWG`,
        thumbnail: Images.outletOffers
      },
      {
        title: 'POS Support',
        videoId: `${Youtube}sQrMbACiXNg?si=WsrgD1BvteSPDtQz`,
        thumbnail: Images.posSupport
      },
      {
        title: "Customer Support",
        videoId: `${Youtube}XFdWYYmIxz8?si=e254FP4FOFu2T9wx`,
        thumbnail: Images.customerSupport
      },
    ]
  },
  {
    chapter: "Maintenance and Cleaning",
    videos: [
      {
        title: "Cleaning Label Printer",
        videoId: `${Youtube}caHxW0t87O0`,
        thumbnail: Images.labelPrinter
      },
    ]
  },
  {
    chapter: "Products and Addons Management",
    videos: [
      { 
        title: "Controlling Product Inventory",
        videoId:`${Youtube}ft1NxRxquhM?si=0OzZCE7c703W-Kn8`,
        thumbnail: Images.controllingProduct
      },
      {
        title: "Products Stock Management",
        videoId: `${Youtube}uD1Yt8Nb85s?si=YAIIH6bL4l3hBnQW`,
        thumbnail: Images.productStockManagement
      },
      {
        title: "Addons Stock Management",
        videoId: `${Youtube}3OKSlpcO8WA?si=sqWyGJD87-UjndzY`,
        thumbnail: Images.addonStockManagement
      },
      {
        title: "Products Listing",
        videoId: `${Youtube}-mOtKeyI17w?si=29j0_6lqxflNssL6`,
        thumbnail: Images.productsListing
      }
    ]
  },
  {
    chapter: "Outlet Reports",
    videos: [
      {
        title: "Order Reports",
        videoId: `${Youtube}PpVQWArcE94?si=cMsR5lDnOnQp27E9`,
        thumbnail: Images.ordersReport
      },
      {
        title: "Critical Stock Reports",
        videoId: `${Youtube}TI4jPg5p818?si=x5p7claaArrJuegX`,
        thumbnail: Images.criticalStockReport
      },
      {
        title: "Stock Transactions Reports",
        videoId: `${Youtube}lXayRXdG0Fc?si=ev2FVEDVJAlpcgdc`,
        thumbnail: Images.stockTransactionReport
      },
      {
        title: "Payment Transactions Reports",
        videoId: `${Youtube}9aBBtGgHKAQ?si=fGBP72aTwZC-ixn1`,
        thumbnail: Images.paymentTransactionReport
      }
    ]
  },
  {
    chapter: "Raw Material Management",
    videos: [
      {
        title: "Damaged Raw Materials",
        videoId: `${Youtube}v-4zbPy8LP4?si=YUbYPM_EohOTqg5z`,
        thumbnail: Images.damagedRawMaterial
      },
      {
        title: 'Inventory Stock Lisiting',
        videoId: `${Youtube}NSTg3t31AmY?si=uDtdsfH9M2ShHRCh`,
        thumbnail: Images.inventoryStockListing
      }
    ]
  },
  {
    chapter: "Orders",
    videos: [
      {
        title: "Complimentary Orders",
        videoId: `${Youtube}dtjHZ3s0dIQ?si=XPbTu_llHtf8bEkK`,
        thumbnail: Images.complimentaryOrder
      },
      {
        title: 'Order not recieved',
        videoId: `${Youtube}KkKn-mlUlsY?si=g3im2lIttb0lvQcg`,
        thumbnail: Images.orderNotReceieved
      }
    ]
  },
];

export default tutorialData;
